import { embedDashboard } from "@superset-ui/embedded-sdk";
import {
  Col,
  Form,
  Layout,
  Row,
  Select,
  //theme,
  Typography,
  Image,
} from "antd";
import { useEffect, useState } from "react";
import { APPCONFIG } from "../../Config";
import useDashboard from "../../lib/hooks/useDashboard";
import { getDashboardDetail } from "../../services/dashboardService";
import WithSidebar from "../../templates/withSidebar";
import "./style.css";
import { useNavigate, useLocation } from "react-router-dom";
import { routes } from "../../routes";
import DashboardCustomerPersona from "./customerpersona";
import DashboardCustomerSegment from "./customersegment";
import DashboardMarketingActionPlan from "./marketingactionplan";
import DashboardFutureCustomerPersona from "./futurecustomerpersona";
import DashboardCustomerPersonaEstate from "./customerpersonaestate";
const { Content } = Layout;
const { Title } = Typography;
const { Option } = Select;
//var  db_value ="";

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // const {
  //   token: { colorBgContainer },
  // } = theme.useToken();
  // eslint-disable-next-line no-use-before-define
  const [dashboardList] = useDashboard();
  const [fetchToken, setFetchToken] = useState("");
  const [superDomain, setSuperDomain] = useState("");
  const [dbValue, setDbValue] = useState("");

  const setSelect = async (values) => {
    //console.log("select dashbaord value =" + values);
    setDbValue("");
    if (values === "future-customer-segment") {
      setDbValue("dashboard_futurecustomersegment");
      return;
    }
    if (values === "63f2854a-b440-479c-afba-12fd6d65218c") {
      setDbValue("dashboard_marketingactionplan");
      return;
    } else if (values === "47d6bb7b-7092-433c-a762-80cd2c50383b") {
      setDbValue("dashboard_customerpersona");
      return;
    } else if (values === "f043bba6-2122-40bc-8456-c98caaefdf76") {
      setDbValue("dashboard_customersegment");
      return;
    } else if (values === "fa05a72c-baf8-11f0-8f16-005056014b8c") {
      setDbValue("dashboard_customerpersonaestate");
      return;
    }
    // else if (values === "d1a21320-307a-11f0-8f16-005056014b8c") {
    //   setDbValue("dashboard_futurecustomerpersona");
    //   return;
    // }
      

    const res = await getDashboardDetail(values);
    const { objectValue } = res.data;
    if (res.data.code === "0000") {
      setFetchToken(objectValue.token);
    }
    embedDashboard({
      id: values,
      supersetDomain: superDomain,
      mountPoint: document.getElementById("my-superset-container"),
      fetchGuestToken: () => objectValue.token,
      dashboardUiConfig: {
        hideTitle: false,
        hideChartControls: true,
        filters: {
          expanded: true,
        },
      },
    });

    return [fetchToken];
  };

  useEffect(() => {
    if (APPCONFIG.GATEWAY_ENDPOINT.includes("dev") === true) {
      setSuperDomain("https://dev-bireport-datamkt.ieat.go.th");
    } else if (APPCONFIG.GATEWAY_ENDPOINT.includes("sit") === true) {
      setSuperDomain("https://sit-bireport-datamkt.ieat.go.th");
    } else if (APPCONFIG.GATEWAY_ENDPOINT.includes("uat") === true) {
      setSuperDomain("https://uat-bireport-datamkt.ieat.go.th");
    } else {
      setSuperDomain("https://bireport-datamkt.ieat.go.th");
    }
  }, []);

  return (
    <WithSidebar defaultBg={dbValue}>
      <Content
        style={{
          margin: "0 16px",
          background:
            dbValue === "" && location.pathname === "/" && "transparent",
        }}
      >
        <Form style={{ marginBottom: 20 }}>
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <div className="flex justify-between items-center">
                <Title level={4} style={{ marginTop: 15, color: "#6442A4" }}>
                  Dashboard
                </Title>
                <div>
                  {/* {roleUser[0]?.isCreate && ( */}
                  <Select
                    placeholder={"ประเด็นติดต่อต่างๆ"}
                    style={{ width: "400px" }}
                    onChange={(value) => setSelect(value)}
                  >
                    <Option value="future-customer-segment">Customer Segment Profile (ลูกค้าอนาคต)</Option>
                    {dashboardList.map((item) => (
                      <Option key={item.dashId} value={item.dashId}>{item.dashNameTh}</Option>
                    ))}
                  </Select>
                  {/* )} */}
                </div>
              </div>
            </Col>
          </Row>
          <Row></Row>
        </Form>
        {/* <div
          id="my-superset-container"
          style={{ width: "80%", height: "75%", position: "absolute" }}
        ></div> */}
          {dbValue === "" && (
            <div
            id="my-superset-container"
            style={{ width: "100%", height: fetchToken ? "100vh" : "100%" }}
          ></div>
          )}
        
          {dbValue === "dashboard_customerpersona" && (
              <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
                <DashboardCustomerPersona />
              </div>
          )}
         {dbValue === "dashboard_futurecustomersegment" && (
           <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
             <DashboardCustomerSegment key="future" future />
           </div>
         )}
         {dbValue === "dashboard_customersegment" && (
              <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
                <DashboardCustomerSegment />
              </div>
          )}
           {dbValue === "dashboard_marketingactionplan" && (
              <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
                <DashboardMarketingActionPlan />
              </div>
          )}
          {dbValue === "dashboard_customerpersonaestate" && (
              <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
                <DashboardCustomerPersonaEstate />
              </div>
          )}
            {/* {dbValue === "dashboard_futurecustomerpersona" && (
              <div id="dashboard-page-view" style={{ width: "100%", height: "100%" }}>
                <DashboardFutureCustomerPersona/>
              </div>
          )} */}
       
      </Content>
    </WithSidebar>
  );
};

export default Dashboard;
